/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

const kindsOfDivorceLinkedSectionStyle = {
  container: {
    textAlign: "center",
  },
  paper: {
    padding: "1rem",
    height: "100%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
  },
  header: {
    marginBottom: "30px",
  },
  text: {
    textAlign: "left",
  },
  infoButton: {
    marginRight: "auto",
    marginLeft: "auto",
  },
};

export default kindsOfDivorceLinkedSectionStyle;
